import { render } from "./BrowseJobItemCard.vue?vue&type=template&id=32df54d4&scoped=true"
import script from "./BrowseJobItemCard.vue?vue&type=script&lang=js"
export * from "./BrowseJobItemCard.vue?vue&type=script&lang=js"

import "./BrowseJobItemCard.vue?vue&type=style&index=0&id=32df54d4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df54d4"]])

export default __exports__